import styled from "styled-components";

export const ErrorMessage = styled.span`
    color: red;
    display: none;
`
export const ResolutionText = styled.div`
    color: white;
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    bottom: 5.5%;
    right: 3%;
    border-radius: 5px;
    font-size: "14px";
    font-family: "Lato";
    padding: 0 15px;
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
    and (orientation: portrait) {
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        width: max-content;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
    and (orientation: landscape) {
        right: 5%;
        width: max-content;
    }
    @media screen and (max-width: 750px){
        text-align:center;
        bottom: 9.5%;
        left: 3%;
    }
`
export const VersionText = styled.div`
    font-size: "14px";
    font-family: "Lato";
     ${ props => props.page==="login" &&
        `color:white;
        position: absolute;
        bottom: 0%;
        right: 3%;
        padding: 10px 15px;
        @media screen and (max-width: 850px){    
            bottom: 5%;    
            left: 0;
            right: 0;
            margin-left: auto;
            margin-right: auto;
            width: 150px;
        }
        @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
        and (orientation: landscape) {
            right: 5%;
            width: max-content;
            bottom: 10%; 
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
        and (orientation: portrait) {
            bottom: 1%; 
    }
        `
    }
    ${ props => props.page==="account" &&
        `display: flex;
        align-items: center;
        justify-content: end;
        width: 100%;
        padding: 0 8%;
        
        @media screen and (max-width: 850px){
            justify-content: center;
        }
        @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
        {
            position:absolute;
            bottom: 6%;
        }
        `
    }  
    
`
export const EmailField = styled.input`
    width: 90%;
    text-indent:10px;
    height: 50px;
    background: #FFFFFF;
    border: 1px solid #E6E6E6;
    border-radius: 8px;

    &:invalid ~ ${ErrorMessage} {
        display: block;
    }
    &:invalid {
        border: 1px solid red;
    }
    // @media screen and (max-width: 850px){  //not required for mobile screens and tablet
    //     width: 350px;
    // }
`;

// export const Text = styled.div([], props => ({
  
//     ...(props.sponsorchild && {
//         color:"#000",
// fontSize: "18px",
// fontFamily: "Lato",
// fontStyle: "normal",
// fontWeight: "600",
// lineHeight: "120%"

//     })
//   }));

export const Text = styled.div`
 ${props => props.sponsorChildName && `
    color: #000;
    font-size: 18px;
    font-family: Lato;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
    margin-left: 10px;
    margin-top: 10px;
     `
}

${props => props.powerClaimsText && `
    padding:10px;
    color: #FF6B00;
    text-align: center;
    font-family: Lato-bold;
    font-size: 18px;
    font-style: italic;
    line-height: 120%; /* 24px */
    `
}

${props => props.sponsorChildId && `
    color: #111;
    font-size: 14px;
    font-family: Lato;
    font-style: normal;
    font-weight: 400;
    line-height: 135%;
    letter-spacing: 0.14px;
    `
}

${props => props.sponsorChildStatus && `
    color: #111;
    font-size: 14px;
    font-family: Lato;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    margin-left: 3px;
    `
}

${props => props.sponsorChildCommunity && `
    color: #111;
    font-size: 14px;
    font-family: Lato;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    margin-left: 3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    `
}

${props => props.sponsorChildDate && `
color: #111;
font-size: 14px;
font-family: Lato;
font-style: normal;
font-weight: 400;
line-height: 135%;
letter-spacing: 0.14px;
min-width: 80px;
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
    `
}

${props => props.sponsorTitle && `
    color: #111;
    font-size: 16px;
    font-family: Lato;
    font-style: normal;
    font-weight: 500;
    line-height: 135%;
    letter-spacing: 0.16px;
    margin-bottom: 10px;
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        margin-left:10px;
    }

    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
    {
        margin-left:10px;
    }
 `
}

${props => props.myacc && `
    color: #000;
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 135%;
    letter-spacing: 0.14px;
     `
} 

${props => props.errormsg && `
    color: red;
    font-family: Lato;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 135%;
    letter-spacing: 0.14px;
     `
} 

${props => props.phoneEdit && `
    margin-top: 26px;
     `
} 

${props => props.homeaddress && `
    color: #000;
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 135%;
    letter-spacing: 0.14px;
    width: 100%;
    white-space: pre;
     `
} 

${props => props.updateProfile && `
    color: #000;
    font-family: Lato-Bold;
    font-size: 24px;
    font-style: normal;
    line-height: 120%; 
     `
}

${props=> props.warningProfile && `
    color: #111;
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    letter-spacing: 0.18px;
    width: 35vw;
    margin-left: 17px;
    @media screen and (max-width: 850px){
        width: 45vw;
    }
`}

${props=> props.warningmsg && `
    color: #111111;
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 21.6px */
    letter-spacing: 0.16px;
    margin-top: 16px;
    width: 41vw;
    @media screen and (max-width: 850px){
        width: 90%;
    }
`}
${props => props.cookieSub && `
    color: #000;
    font-family: Lato-Bold;
    font-size: 17px;
    font-style: normal;
    line-height: 120%; 
    margin-top: 16px;
     `
}
${props=> props.cookiesmsg && `
    color:  #111111;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 18px */
    letter-spacing: 0.16px;
    width: 41vw;
    margin-top: 16px;
    @media screen and (max-width: 850px){
        width: 90%;
    }
    @media screen and (min-width: 1200px) and (max-width:1400px) {
        font-size: 14px;
        line-height: 125%;
    } 
`}

${props=> props.warninginfo && `
    color:  #111111;
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 18px */
    letter-spacing: 0.18px;
    width: 41vw;
    @media screen and (max-width: 850px){
        width: 90%;
    }
`}
${props=> props.successHeader && `
    color: #111;
    text-align: center;
    font-family: Lato;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
`}

${props=> props.successmodalmsg && `
    color: #111;
    text-align: center;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    margin-top: 13px;
`}

${props=> props.successtrackermsg && `
color: #111;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 135%; /* 21.6px */
letter-spacing: 0.16px;
`}

${props=> props.acclabel && `
    margin-top: 5px;
    font-size: 16px;
`}

${props=> props.yoursponsor && `
color: #111;
font-family: Lato-Bold;
font-size: 16px;
font-style: normal;
line-height: 135%; /* 21.6px */
letter-spacing: 0.16px;
`}

${props=> props.preftype && `
color: #111;
font-family: Lato-Bold;
font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 135%; /* 21.6px */
letter-spacing: 0.16px;
width: -webkit-fill-available;
@media screen and (max-width: 600px){
    flex: 2;
  }
`}

${props=> props.prefsubtype && `
color: #000;
font-family: Lato;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 135%; /* 18.9px */
letter-spacing: 0.14px;
`}

${props=> props.prefsubtype1 && `
color: #000;
font-family: Lato;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 135%; /* 18.9px */
letter-spacing: 0.14px;
margin-top:3px;
width: -webkit-fill-available;
margin-left: -10%;
@media screen and (max-width: 600px){
    flex: 3;
    margin-left: 2%;
  }
`}
${props=> props.prefsubtype2 && `
color: #000;
font-family: Lato;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 135%; /* 18.9px */
letter-spacing: 0.14px;
width: -webkit-fill-available;
margin-left: -10%;
@media screen and (max-width: 600px){
    flex: 3;
    margin-left: 2%;
  }
@media screen and (min-width: 1200px) and (max-width: 1400px){
    margin-left: -8%;
  }
`}

${props=> props.preftypeMargin && `
color: #111;
font-family: Lato-Bold;
font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 135%; /* 21.6px */
letter-spacing: 0.16px;
margin-top: 24px;
`}


${props=>props.prefPadding &&`
padding-bottom: 32px;
border-bottom: 1px solid #C9C9C9;
`}

${props=>props.prefSelect &&`
text-align: center;
font-family: Lato-Bold;
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: 120%;
`}
${props=>props.clickHere && `
color: #FFF;
text-align: center;
font-family: Lato;
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: 115%; /* 16.1px */
letter-spacing: 0.14px;
`}

${props=>props.writeToChild && `
color: #666;
font-family: Lato;
font-size: 15px;
font-style: normal;
line-height: 130%; /* 16.1px */
letter-spacing: 0.14px;
padding: 10px 15px;
white-space: pre-line;
`}

${props=>props.writeToChild2 && `
color: #666;
font-family: Lato;
font-size: 15px;
font-style: normal;
line-height: 130%; /* 16.1px */
letter-spacing: 0.14px;
padding: 0px 15px;
white-space: pre-line;
`}

${props=> props.homedisclaimer && `
    position: absolute;
    bottom: 34px;
    right: 34px;
    color: #fff;
    @media screen and (min-width: 400px){
        bottom:8vh;
    }
    @media screen and (max-width: 480px){
        text-align: center;
        margin-bottom: 0%;
        right: unset;
        padding: 0 30px;
        line-height: 19px;
    }
    @media screen and (min-width: 481px) and (max-width: 850px){
        text-align: center;
        margin-bottom: 0%;
        right: unset;
        padding: 0 30px;
    }
`}

${props=> props.mblhomedisclaimer && `
    @media screen and (max-width: 480px){
        width: 60%;
        margin-left: 10px;
        color: rgb(255, 255, 255);
    }
`}

${props=> props.PrivacyTitle && `
    color: rgb(17, 17, 17);
    font-family: Lato-Bold;
    font-size: 16px;
    font-style: normal;
    line-height: 135%;
    letter-spacing: 0.16px;
`}

${props=> props.DeleteOnlineAcc && `
    color: rgba(0, 0, 0, 1)
    font-family: Lato;
    font-size: 24px;
    font-style: normal;
    line-height: 135%;
    font-weight:500;
    letter-spacing: 0.16px;
`}
${props=> props.WeAreSorry && `
    color: rgba(0, 0, 0, 1)
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 135%;
    margin-top:0.5rem;
    margin-bottom:10px;
`}
${props=> props.BeforeYouProceed && `
    color: rgba(0, 0, 0, 1)
    font-family: Lato;
    font-size: 15px;
    font-weight: 400;
    line-height:28px;
`}
${props=> props.DeleteAccountData && `
    color: rgba(0, 0, 0, 1)
    font-family: Lato;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height:28px;
    position: relative;
    padding-left: 20px;
    :before{
        content: "•";
        position: absolute;
        left: 0;
        top: 0px;
        font-size: 20px; 
        color: rgba(0, 0, 0, 1);
    }
`}

${props => props.DeleteAccTitle && `
    color: #000;
    font-family: Lato;
    font-size: 24px;
    font-style: normal;
    font-weight:500;
    line-height: 120%; 
    @media screen and (max-width: 750px){
        text-align:center;
        margin-top: 3%;
    }
     `
}


${props=> props.SubmitDeleteDesc && `
    color: #111;
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    letter-spacing: 0.18px;
    width: 30vw;
    margin-left: 2rem;
    @media screen and (max-width: 750px){
        width: 80vw;
        margin: 1rem;
        margin-left: 0;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        width: 50vw;
        margin-left: 2rem;
        margin-right: 2rem;
    }
`}

${props=> props.DeleteAcc && `
color: rgb(0, 0, 0);
font-family: Lato;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 135%;
letter-spacing: 0.14px;
margin-top: 31px;
cursor: pointer;
text-decoration: underline;
`}


`;

export const Phone = styled.input`
    width: auto;
    height: 27px;
    padding-bottom: 5px;
    color: #111;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 135%; /* 21.6px */
    letter-spacing: 0.16px;
    border-bottom: 1px solid #C9C9C9;
    text-overflow: ellipsis;

    // &:invalid ~ ${ErrorMessage} {
    //     display: block;
    // }
    // &:invalid {
    //     border: 1px solid red;
    // }
`;

export const GiveInfoText=styled.p`
height: auto;
font-family: 'Lato-Bold';
font-style: normal;
font-size: 28px;
text-align: center;
color: #111111;
margin-top: 10px;

${props=> props.name && `
    margin-top: 10px;
    position: absolute;
`}

${props=> props.desc && `
    font-size: 24px;
    max-height: 130px;
    overflow-y: auto;
    z-index:1;
    position:relative;
    margin-top: 25%;
    padding: 0 20px;
    font-family: Lato;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 135%;
    text-align: center;
    letter-spacing: 0.01em;
    color: rgb(17, 17, 17);
`}

${props=> props.birthdayInfo && `
margin-top: 7%;
margin-left: 2vw;
`}
`